import AnimationMnager from '../module/animation';
import effectManager from '../module/effect';
import topKv from './topKV';

const animation = new AnimationMnager();
const effect = new effectManager();
const kv = new topKv();

export default class topManager {
    constructor() {


    }
    init(){
        effect.svgInit();
        TweenMax.set($("#p-kv"),{ "height":window.innerHeight })

    }
    render(mouse){

        kv.render(mouse);
    }
    resize(){
        kv.resize();
        if(!Useragnt.mobile) TweenMax.set($("#p-kv"),{ "height":window.innerHeight })
    }
}